import type {FC} from 'react';
import clsx from 'clsx';
import Link from 'next/link';
import {checkIfLinkShouldUseAnchorTag} from 'utils';

interface Props {
	href?: string;
	targetBlank?: boolean;
	text: string;
	className?: string;
}

export const InlineLinkRender: FC<Props> = ({href, targetBlank, text, className}) => {
	const linkShouldUseAnchorTag = checkIfLinkShouldUseAnchorTag(href);

	return (
		<>
			{linkShouldUseAnchorTag ? (
				<a
					href={href ?? '#'}
					target={targetBlank ? '_blank' : undefined}
					className={clsx(
						'text-primary-main',
						'underline',
						'hover:no-underline',
						'hover:bg-primary-extraLight',
						'font-semibold',
						'decoration-secondary',
						className,
					)}
				>
					{text}
				</a>
			) : (
				<Link
					href={href ?? '#'}
					target={targetBlank ? '_blank' : undefined}
					className={clsx(
						'text-primary-main',
						'underline',
						'hover:no-underline',
						'hover:bg-primary-extraLight',
						'font-semibold',
						'decoration-secondary',
						className,
					)}
				>
					{text}
				</Link>
			)}
		</>
	);
};
